import CircularProgress from '@material-ui/core/CircularProgress';
import Grid from '@material-ui/core/Grid';
import React from 'react';
import Typography from '@material-ui/core/Typography';

import UserList from '../../Atoms/UserList';

export interface INotificationReview {
    name: string;
    isPushNotification: boolean;
    users_loading: boolean;
    distinctUsers: any[];
    usersTargetType: 'all' | 'custom';
    activeUsersCount: number;
}

const NotificationReview = ({
    // combined,
    distinctUsers,
    isPushNotification,
    name,
    users_loading,
    usersTargetType,
    activeUsersCount
}: INotificationReview) => {
    return (
        <Grid container spacing={3}>
            <Grid container item spacing={3}>
                <Grid item sm={6} xs={12}>
                    <Typography component="h5" variant="h6">
                        Is this a push notification?
                    </Typography>
                    {isPushNotification ? 'Yes' : 'No'}
                </Grid>
                <Grid container direction="column" item sm={6} xs={12}>
                    <Typography color="textPrimary" component="h5" variant="h6">
                        Notification content:
                    </Typography>
                    <div>
                        <Typography component="p" paragraph={true} variant="body1">
                            {name}
                        </Typography>
                    </div>
                </Grid>
            </Grid>
            <Grid alignItems="center" container direction="column" item xs={12}>
                <Typography component="h5" variant="h6">
                    Recipients:
                </Typography>
                {!users_loading && usersTargetType === 'all' && <span>{activeUsersCount}</span>}
                {users_loading && <CircularProgress color="secondary" />}
                {!users_loading && usersTargetType === 'custom' && <UserList editable={false} id="Notification-review" users={distinctUsers} />}
            </Grid>
        </Grid>
    );
};

export default NotificationReview;
